import moment from 'moment';
import _ from 'lodash';
import { instBundle } from '@/axios.js';
const axiosAdmin2 = instBundle.axiosAdmin2;

const strToArr = str =>
	str
		? str
				.split(',')
				.map(v => v.trim())
				.filter(v => v.length > 0)
				.reduce((acc, v) => {
					if (acc.indexOf(v) < 0) {
						acc.push(v);
					}
					return acc;
				}, [])
		: [];

const state = getDefaultState();
function getDefaultState() {
	return {
		registerComplete: false,
		idProduct: null,
		isInquiry: false,
		isDisplayList: [
			{ id: true, value: '전시' },
			{ id: false, value: '비전시' },
		],
		isDisplay: true,
		isDiscontinueList: [
			{ id: false, value: '미단종' },
			{ id: true, value: '단종' },
		],
		isDiscontinue: false,
		isDisplayDalphaList: [
			{ id: true, value: '노출' },
			{ id: false, value: '비노출' },
		],
		isDisplayDalpha: true,
		idBrand: null,
		brandTitle: null,
		storeList: null,
		storeListOrigin: null,
		brandTypeList: [],
		productTitle: '',
		firstCategoryList: null,
		secondList: [],
		selectedCategoryList: [],
		keywordList: [],
		productTagList: [],
		primarySecondCategoryIdx: 0,
		releaseDate: '',
		imgSrc: null,
		imgFileName: null,
		imgFileSize: null,
		imgFileType: null,
		hasSaveFile: false,
		fileDir: null,
		fileOrgName: null,
		fileSaveName: null,
		fileSize: null,
		fileType: null,
		volume: '',
		price: '',
		colorType: '',
		colors: '',
		etcs: '',
		productText: '',
		factorsDisplayList: [
			{ id: true, value: '전시' },
			{ id: false, value: '미전시' },
		],
		factorsDisplay: true,
		factorList: [],
		commentList: [],
		ImageDTO: {},
		savedFactorsLength: 0,
		ratingAvg: 0,
		commentCount: 0,
		readCount: 0,
		wishCount: 0,
		productScore: 0,
		awardList: [],
		updateInfo: '',
		createInfo: '',
		categoryMappings: null,
		keywordCheckListOrigin: [],
		factorsInsertedDate: '-',
		factorsModifiedDate: '-',
		groupId: null,
		productGroupList: [],
		original: {},
		memo: '',
		isNewComment: false,
	};
}

const getters = {
	get: state => key => state[key],
	validation: (state, getters) => pageType => {
		if (!state.idBrand) {
			// 브랜드명을 입력하지 않은 경우
			alert('브랜드명을 입력하세요.');
			return false;
		}
		if (!state.productTitle) {
			// 제품명을 입력하지 않은 경우
			alert('제품명을 입력하세요.');
			return false;
		}
		if (!state.productText) {
			// 제품 설명을 입력하지 않은 경우
			alert('제품 설명을 입력하세요.');
			return false;
		}
		if (
			!Array.isArray(state.categoryMappings) ||
			state.categoryMappings.length < 1
		) {
			// 카테고리 선택이 없는 경우
			alert('카테고리를 선택하세요.');
			return false;
		}
		if (state.categoryMappings.every(item => !item.isPrimary)) {
			// 대표 카테고리 선택하지 않은 경우
			alert('대표 카테고리를 선택하세요.');
			return false;
		}
		if (
			state.selectedCategoryList.some(item =>
				getters.hasEmptyCategory(item.nextCategoryDepth)
			)
		) {
			return false;
		}
		const checkOverlap = state.selectedCategoryList.some((item, idx) => {
			return state.selectedCategoryList.some(
				(item2, idx2) => idx !== idx2 && _.isEqual(item, item2)
			);
		});
		if (checkOverlap) {
			// 3차 카테고리가 중복이 있는 경우
			alert('동일한 카테고리는 등록할 수 없습니다.');
			return false;
		}
		if (!state.ImageDTO.fileSaveName) {
			// 사진이 등록되지 않은 경우
			alert('사진을 선택하세요.');
			return false;
		}
		if (!state.volume) {
			// 용량을 입력하지 않은 경우
			alert('용량을 입력하세요.');
			return false;
		}
		if (state.isNewComment) {
			// 코멘트 입력 후 입력버튼 안눌렀을때
			alert('코멘트 입력 후 입력 버튼을 눌러주세요.');
			return false;
		}
		return true;
	},
	params:
		state =>
		({ rootState }) => {
			const params = {};
			if (state.brandTypeList?.length)
				params.brandTypeList = state.brandTypeList;
			if (state.colorType) params.colorType = state.colorType;
			params.colors = strToArr(state.colors);
			params.etcs = strToArr(state.etcs);
			if (state.factorList?.length) params.factorList = state.factorList;
			params.factorsDisplay = state.factorsDisplay;
			if (state.ImageDTO.hasOwnProperty('fileSaveName')) {
				Object.keys(state.ImageDTO).map(key => {
					params[key] = state.ImageDTO[key];
				});
			}
			if (typeof state.idBrand === 'number')
				params.idBrand = state.idBrand;
			if (state.idProduct) params.idProduct = state.idProduct;
			params.insertIdRegister = rootState.login.idRegister;
			params.isDiscontinue = state.isDiscontinue;
			params.isDisplayDalpha = state.isDisplayDalpha;
			params.isDisplay = state.isDisplay;
			if (state.price) params.price = Number(state.price);
			if (state.productText) params.productText = state.productText;
			if (state.productTitle) params.productTitle = state.productTitle;
			if (state.volume) params.volume = state.volume;
			if (state.releaseDate) {
				params.releaseYear = state.releaseDate.split('-')[0];
				params.releaseMonth = state.releaseDate.split('-')[1];
			}
			params.productTagList = state.productTagList;
			if (state.categoryMappings && state.categoryMappings?.length > 0) {
				params.categoryMappings = state.categoryMappings;
				params.primarySecondCategory =
					state.categoryMappings[
						state.primarySecondCategoryIdx
					].idSecondCategory;
			}

			if (state.groupId && state.groupId != state.idProduct) {
				params.groupId = state.groupId;
			}
			if (state.memo) params.memo = state.memo;
			return params;
		},
	hasEmptyCategory: state => nextCategoryDepth => {
		if (nextCategoryDepth) {
			alert(`${nextCategoryDepth}차 카테고리를 선택하세요.`);
			return true;
		}
		return false;
	},
	hasSameCategory:
		state =>
		(
			category1 = null,
			category2 = null,
			category3 = null,
			nextCategoryDepth
		) => {
			const hasSame = state.selectedCategoryList.some(item => {
				[1, 2, 3].forEach(idx => {
					if (!item.hasOwnProperty(`category${idx}`))
						item[`category${idx}`] = null;
				});
				return _.isEqual(item, {
					category1,
					category2,
					category3,
					nextCategoryDepth,
				});
			});
			if (hasSame) {
				alert('이미 추가된 카테고리입니다.');
			}
			return hasSame;
		},
};

const mutations = {
	init(state) {
		state = getDefaultState();
	},
	setImgDto(state, args) {
		state.ImageDTO = args;
	},
	togglePageType(state, bool) {
		state.isInquiry = bool;
	},
	stateChange(state, changeList) {
		changeList.forEach(item => {
			if (state[item.key] !== undefined) {
				state[item.key] = item.value;
			}
		});
	},
	selectedCategoryListAdd(
		state,
		{ category1, category2, category3, keywordList, nextCategoryDepth }
	) {
		state.selectedCategoryList = [
			...state.selectedCategoryList,
			{ category1, category2, category3, nextCategoryDepth },
		];
		const newKeywordList = _.cloneDeep(state.keywordList);
		newKeywordList[state.selectedCategoryList?.length - 1] = keywordList;
		state.keywordList = newKeywordList;
	},
	deleteCategory(state, { idx, commit }) {
		const selectedCategoryList = _.cloneDeep(state.selectedCategoryList);
		state.selectedCategoryList = null;
		setTimeout(() => {
			state.selectedCategoryList = selectedCategoryList.filter(
				(item, itemIdx) => itemIdx !== idx
			);
			commit('toggleSpinner', false);
		}, 0);
		const keywordList = state.keywordList;
		keywordList.splice(idx, 1);
		state.keywordList = keywordList;
		const primarySecondCategoryIdx = state.primarySecondCategoryIdx;
		if (primarySecondCategoryIdx === idx) {
			state.primarySecondCategoryIdx = 0;
		} else if (primarySecondCategoryIdx > idx) {
			state.primarySecondCategoryIdx--;
		}
	},
	keywordCheckedListChange(state, newList) {
		state.productTagList = newList;
	},
	categoryChange(state, changes) {
		state.selectedCategoryList = state.selectedCategoryList.map(
			(item, idx) => {
				if (idx === changes.idx) {
					item = {
						category1: changes.category1,
						category2: changes.category2,
						category3: changes.category3,
						nextCategoryDepth: changes.nextCategoryDepth,
					};
				}
				return item;
			}
		);
		const keywordList = state.keywordList;
		keywordList[changes.idx] = changes.keywordList;
		state.keywordList = keywordList;
	},
};

const actions = {
	async getProductDetail({ state, commit }, idProduct) {
		try {
			const { data } = await axiosAdmin2.get(
				`/api/products/${idProduct}`
			);
			state = Object.assign(state, data.data);

			const factorInsertDate = state.factorsInsertedDate;
			const factorModifyDate = state.factorsModifiedDate;

			state.factorsInsertedDate =
				factorInsertDate !== '19801221232000' && factorInsertDate
					? moment(factorInsertDate, 'YYYYMMDDHHmmSS').format(
							'YYYY-MM-DD HH:mm'
						)
					: '-';
			state.factorsModifiedDate =
				factorModifyDate !== '19801221232000' &&
				state.factorsModifiedDate
					? moment(
							state.factorsModifiedDate,
							'YYYYMMDDHHmmSS'
						).format('YYYY-MM-DD HH:mm')
					: '-';

			state.brandTypeList = state.storeList?.map(
				item => item.idBrandType
			);

			if (state.releaseYear && state.releaseMonth) {
				state.releaseDate = `${state.releaseYear}-${state.releaseMonth}`;
			}

			if (state.fileSaveName) {
				commit('setImgDto', {
					fileOrgName: state.fileOrgName,
					fileSaveName: state.fileSaveName,
					fileDir: state.fileDir,
					fileSize: state.fileSize,
					fileType: state.fileType,
				});
			}
			if (state.price) state.price = state.price.toString();
			if (Array.isArray(state.factorList)) {
				state.factorList = state.factorList?.map(item => ({
					factorIdx: item.factorIdx,
					orderIndex: item.orderIndex,
					factorName: `${item.factorKorean}(${item.factorEnglish})`,
				}));
				state.savedFactorsLength = state.factorCount;
			}
			state.awardList = state.awardList?.map(item => {
				const category = [];
				if (item.firstCategoryText)
					category.push(item.firstCategoryText);
				if (item.secondCategoryText)
					category.push(item.secondCategoryText);
				if (item.thirdCategoryText)
					category.push(item.thirdCategoryText);
				return {
					id: `${item.idHitProducts}${item.idHitCategory}${item.parentId}`,
					hitText: item.hitText,
					parsedSortKey: isNaN(Number(item.rankLabel))
						? `${item.rankLabel}`
						: `${item.rankLabel}위`,
					parsedCategory: `${category.join('/')} 부문`,
				};
			}) || [];
			state.updateInfo = state.modifiedDate
				? `${moment(state.modifiedDate, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm')} (${state.updateRegisterName || 'admin'})`
				: '-';
			state.createInfo = state.createDate
				? `${moment(state.createDate, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm')} (${state.insertRegisterName || 'admin'})`
				: '-';
			state.selectedCategoryList = state.categoryList?.map(
				(item, idx) => {
					if (item.isPrimary) state.primarySecondCategoryIdx = idx;
					return {
						category1: item.idFirstCategory,
						category2: item.idSecondCategory,
						category3: item.idThirdCategory,
						nextCategoryDepth: null,
					};
				}
			);
			state.productTagList = state.productTagList?.map(tag => tag.tag);
			if (state.productGroupList && state.productGroupList?.length) {
				let root = state.productGroupList.pop();
				state.productGroupList.unshift(root);
				state.groupId = root.idProduct;
			} else {
				state.groupId = null;
			}
			state.original = { ..._.omit(state, 'original') };
		} catch (err) {
			console.error(err);
			alert(err);
		}
	},
	async register({ getters, state, commit, rootState }, args) {
		state.categoryMappings = args.categoryMappings;
		try {
			const validation = getters['validation']('register');
			if (!validation) return;
			if (state.ImageDTO.uploadFlag === true) {
				const { data } = await axiosAdmin2.post(
					`/api/common/image`,
					state.ImageDTO
				);
				commit('setFileData', data.data);
			}
			{
				const params = getters['params']({ rootState });
				const { data } = await axiosAdmin2.post(
					'/api/products',
					params
				);
				if (data.msg) {
					return data.msg;
				}
				if (data.idProduct) {
					state.idProduct = data.idProduct;
				}
			}
			return true;
		} catch (err) {
			console.error(err);
			alert(
				`제품${args.isRegister ? '등록' : '수정'}에 실패했습니다. 개발팀에 문의하세요.`
			);
			return false;
		}
	},
	async getCommentList({ state }, id) {
		try {
			const { data } = await axiosAdmin2.get(
				`/api/products/adminCommnet/${id}`
			);
			state.commentList = data.map(item => {
				item.parsedCreateDate = item.createDate
					.split('')
					.map((str, idx) => {
						if (idx === 4 || idx === 6) {
							return `.${str}`;
						} else if (idx === 8) {
							return ` ${str}`;
						} else if (idx === 10 || idx === 12) {
							return `:${str}`;
						} else {
							return str;
						}
					})
					.join('');
				return item;
			});
		} catch (err) {
			console.error(err);
			alert(
				'제품 댓글 리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
			);
		}
	},
	async getCategoryList({}, { idParentCategory, level }) {
		const levelName = (level => {
			if (level === 1) return 'First';
			if (level === 2) return 'Second';
			if (level === 3) return 'Third';
		})(level);
		try {
			const params = {};
			if (typeof idParentCategory === 'number') {
				params.idParentCategory = idParentCategory;
			}
			const { data } = await axiosAdmin2.get(
				`/api/categories/level/${level}`,
				{ params }
			);
			const categoryList = data.data.map(item => ({
				id: item[`id${levelName}Category`],
				value: item[`${levelName.toLowerCase()}CategoryText`],
				hasChild: level === 1 ? true : item.hasChild,
			}));
			categoryList.unshift({
				id: null,
				value: `${level}차 카테고리 선택`,
				hasChild: false,
			});
			if (level === 1) {
				state.firstCategoryList = categoryList;
			}
			return categoryList;
		} catch (err) {
			console.error(err);
			alert('카테고리를 불러오는데 실패했습니다. 개발팀에 문의하세요.');
		}
	},
	async initControllerData({ state, dispatch }) {
		try {
			state = _.assign(state, getDefaultState());
			const { data } = await axiosAdmin2.get('/api/products/store');
			state.storeListOrigin = data.data.filter(
				item => item.isDisplay === 'Y'
			);
			await dispatch('getCategoryList', { level: 1 });
		} catch (err) {
			console.error(err);
			alert('초기 데이터 불러오기에 실패했습니다.');
		}
	},
	async getCategoryKeyword({}, { id, level }) {
		const { data } = await axiosAdmin2.get(
			`/api/categories/level/${level}/category/${id}/search-keywords-simple`
		);
		return data.data.map(item => ({
			id: item.idKeyword,
			value: item.keywordText,
		}));
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
